import { render, staticRenderFns } from "./NewContentsPdf.vue?vue&type=template&id=6f31b07d&scoped=true&"
import script from "./NewContentsPdf.vue?vue&type=script&lang=ts&"
export * from "./NewContentsPdf.vue?vue&type=script&lang=ts&"
import style0 from "./NewContentsPdf.vue?vue&type=style&index=0&id=6f31b07d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f31b07d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
